<template>
  <div>
    <div class="flex wrap fill fill-h">
      <div
        v-if="$store.state.app.pages['home']"
        class="flex wrap align-center"
        style="width: 100%;"
      >
        <pages pagetitle="home" key="home"  style="width: 100%"/>
        <!-- <div class="wrap flexy around flex align-center" style="min-width: 240px; width: 100%;">
          <div
            v-if="!$store.state.app.pages['home'].text.indexOf('<iframe')"
            class="between fill flexy flex center flex-end wrap p16"
          >
            <div class="container p8 fit" style="max-width: 480px;">
              <p class="xxl-font p16">{{$store.state.app.basics['app name']}}</p>
              <div class="p16">{{$store.state.app.basics.mission}}</div>
              <span
                :key="itemKey"
                class="p16 flexy"
                v-for="(item, itemKey) in $store.state.app.basics.items"
              >
                <router-link :to="`/list/${item.name}`">
                  <i :class="item.icon"></i>
                  {{item.name.toUpperCase()}}
                </router-link>
              </span>
              <login/>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      action: false,
      features: [
        {
          name: "Sell Things",
          msg:
            "All kinds of e-commerce setups, ready to go. P2P, B2B, B2C, C2B, data, tokens, etc",
          icon: "fas fa-shopping-cart"
        },
        {
          name: "List Events",
          msg:
            "Use event listings with RSVP features and secret options to keep on top of event organizations.",
          icon: "fas fa-calendar"
        },
        {
          name: "Seek Gigs",
          msg:
            "Insightful communication and reputation tools for job seekers, HR types, and start-up founders.",
          icon: "fas fa-briefcase"
        },
        {
          name: "Connect Networks",
          msg:
            "Connect friends, stakeholders, bots, and IoT to create meaningful, interconnected value.",
          icon: "fas fa-project-diagram"
        }
      ],
      rollYourOwn: "",
      rollSrc: "",
      show: {},
      showError: false
    };
  },
  methods: {
    scrollUp() {
      return window.scrollTo(0, 0);
    }
  },
  mounted() {
    !this.$store.state.app.basics.live && this.$store.state.app.itemTypes.length === 0 && !this.$store.state.app.pages.home.text && this.$store.state.app.pages.home.components.length == 0 && (!this.$store.state.app.basics.menus.home || this.$store.state.app.basics.menus.home.links.length == 0) && this.$set(this.$store.state.show, "admin", true);
  }
};
</script>

<style>
header {
  margin: 0;
  max-height: 18vh;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}

header b {
  font-size: 20px;
  letter-spacing: 0.02em;
  font-weight: 600;
  box-sizing: border-box;
}
.white {
  color: white;
}

.hello-image {
  width: 100%;
}
.hello {
  max-width: 540px;
}

/* .fas {
  color: white;
  text-shadow: 0.01em 0.01em 0 rgba(72, 165, 201, 0.2),
    -0.01em -0.01em 0 rgba(43, 127, 63, 0.2), 0 0 0.1em rgba(0, 0, 0, 0.103);
} */
</style>
 